export default __webpack_public_path__ + "static/media/dot_40alpha.e68599ce.svg";